interface Stat {
  value: string;
  label: string;
}

interface LabelSelectorProps {
  labels: string[];
  selected: string;
  onChange: (label: string) => void;
  stats?: Stat[];
}

export default function LabelSelector({
  labels,
  selected,
  onChange,
  stats,
}: LabelSelectorProps) {
  return (
    <div
      className="border border-stone-200 rounded"
      style={{ backgroundColor: "#faf9f4" }}
    >
      <div className="flex items-center justify-between px-3 py-2 border-b border-stone-200">
        <p
          className="font-montserrat font-semibold text-stone-600 uppercase"
          style={{ fontSize: "13px", letterSpacing: "0.14em" }}
        >
          Labels
        </p>
      </div>
      <ul className="py-1">
        {labels.map((label) => {
          const isSelected = label === selected;
          return (
            <li key={label}>
              <button
                type="button"
                onClick={() => onChange(label)}
                className="w-full flex items-center gap-2 px-3 py-1.5 hover:bg-stone-100 text-left"
                style={{ transition: "background 0.15s ease" }}
              >
                <span
                  className="w-3 h-3 rounded-full flex-shrink-0 border"
                  style={{
                    backgroundColor: isSelected ? "#6d0016" : "transparent",
                    borderColor: isSelected ? "#6d0016" : "#aaa",
                    transition: "all 0.15s ease",
                  }}
                />
                <span
                  className="font-montserrat text-stone-700"
                  style={{ fontSize: "14px", letterSpacing: "0.03em" }}
                >
                  {label}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
